import { jsx as d } from "react/jsx-runtime";
import * as p from "react";
import { getDefaultClassNames as x, DayPicker as w } from "react-day-picker";
import { cn as e } from "../../lib/utils.js";
import { buttonVariants as b, Button as y } from "./button.js";
import { ChevronLeftIcon as _, ChevronRightIcon as h, ChevronDownIcon as v } from "lucide-react";
function R({
  className: c,
  classNames: g,
  showOutsideDays: r = !0,
  captionLayout: o = "label",
  buttonVariant: u = "ghost",
  locale: n,
  formatters: f,
  components: i,
  ...m
}) {
  const t = x();
  return /* @__PURE__ */ d(
    w,
    {
      showOutsideDays: r,
      className: e(
        "group/calendar bg-background p-2 [--cell-radius:var(--radius-md)] [--cell-size:--spacing(7)] in-data-[slot=card-content]:bg-transparent in-data-[slot=popover-content]:bg-transparent",
        String.raw`rtl:**:[.rdp-button\_next>svg]:rotate-180`,
        String.raw`rtl:**:[.rdp-button\_previous>svg]:rotate-180`,
        c
      ),
      captionLayout: o,
      locale: n,
      formatters: {
        formatMonthDropdown: (a) => a.toLocaleString(n == null ? void 0 : n.code, { month: "short" }),
        ...f
      },
      classNames: {
        root: e("w-fit", t.root),
        months: e(
          "relative flex flex-col gap-4 md:flex-row",
          t.months
        ),
        month: e("flex w-full flex-col gap-4", t.month),
        nav: e(
          "absolute inset-x-0 top-0 flex w-full items-center justify-between gap-1",
          t.nav
        ),
        button_previous: e(
          b({ variant: u }),
          "size-(--cell-size) p-0 select-none aria-disabled:opacity-50",
          t.button_previous
        ),
        button_next: e(
          b({ variant: u }),
          "size-(--cell-size) p-0 select-none aria-disabled:opacity-50",
          t.button_next
        ),
        month_caption: e(
          "flex h-(--cell-size) w-full items-center justify-center px-(--cell-size)",
          t.month_caption
        ),
        dropdowns: e(
          "flex h-(--cell-size) w-full items-center justify-center gap-1.5 text-sm font-medium",
          t.dropdowns
        ),
        dropdown_root: e(
          "relative rounded-(--cell-radius)",
          t.dropdown_root
        ),
        dropdown: e(
          "absolute inset-0 bg-popover opacity-0",
          t.dropdown
        ),
        caption_label: e(
          "font-medium select-none",
          o === "label" ? "text-sm" : "flex items-center gap-1 rounded-(--cell-radius) text-sm [&>svg]:size-3.5 [&>svg]:text-muted-foreground",
          t.caption_label
        ),
        table: "w-full border-collapse",
        weekdays: e("flex", t.weekdays),
        weekday: e(
          "flex-1 rounded-(--cell-radius) text-[0.8rem] font-normal text-muted-foreground select-none",
          t.weekday
        ),
        week: e("mt-2 flex w-full", t.week),
        week_number_header: e(
          "w-(--cell-size) select-none",
          t.week_number_header
        ),
        week_number: e(
          "text-[0.8rem] text-muted-foreground select-none",
          t.week_number
        ),
        day: e(
          "group/day relative aspect-square h-full w-full rounded-(--cell-radius) p-0 text-center select-none [&:last-child[data-selected=true]_button]:rounded-r-(--cell-radius)",
          m.showWeekNumber ? "[&:nth-child(2)[data-selected=true]_button]:rounded-l-(--cell-radius)" : "[&:first-child[data-selected=true]_button]:rounded-l-(--cell-radius)",
          t.day
        ),
        range_start: e(
          "relative isolate z-0 rounded-l-(--cell-radius) bg-muted after:absolute after:inset-y-0 after:right-0 after:w-4 after:bg-muted",
          t.range_start
        ),
        range_middle: e("rounded-none", t.range_middle),
        range_end: e(
          "relative isolate z-0 rounded-r-(--cell-radius) bg-muted after:absolute after:inset-y-0 after:left-0 after:w-4 after:bg-muted",
          t.range_end
        ),
        today: e(
          "rounded-(--cell-radius) bg-muted text-foreground data-[selected=true]:rounded-none",
          t.today
        ),
        outside: e(
          "text-muted-foreground aria-selected:text-muted-foreground",
          t.outside
        ),
        disabled: e(
          "text-muted-foreground opacity-50",
          t.disabled
        ),
        hidden: e("invisible", t.hidden),
        ...g
      },
      components: {
        Root: ({ className: a, rootRef: l, ...s }) => /* @__PURE__ */ d(
          "div",
          {
            "data-slot": "calendar",
            ref: l,
            className: e(a),
            ...s
          }
        ),
        Chevron: ({ className: a, orientation: l, ...s }) => l === "left" ? /* @__PURE__ */ d(_, { className: e("size-4", a), ...s }) : l === "right" ? /* @__PURE__ */ d(h, { className: e("size-4", a), ...s }) : /* @__PURE__ */ d(v, { className: e("size-4", a), ...s }),
        DayButton: ({ ...a }) => /* @__PURE__ */ d(z, { locale: n, ...a }),
        WeekNumber: ({ children: a, ...l }) => /* @__PURE__ */ d("td", { ...l, children: /* @__PURE__ */ d("div", { className: "flex size-(--cell-size) items-center justify-center text-center", children: a }) }),
        ...i
      },
      ...m
    }
  );
}
function z({
  className: c,
  day: g,
  modifiers: r,
  locale: o,
  ...u
}) {
  const n = x(), f = p.useRef(null);
  return p.useEffect(() => {
    var i;
    r.focused && ((i = f.current) == null || i.focus());
  }, [r.focused]), /* @__PURE__ */ d(
    y,
    {
      variant: "ghost",
      size: "icon",
      "data-day": g.date.toLocaleDateString(o == null ? void 0 : o.code),
      "data-selected-single": r.selected && !r.range_start && !r.range_end && !r.range_middle,
      "data-range-start": r.range_start,
      "data-range-end": r.range_end,
      "data-range-middle": r.range_middle,
      className: e(
        "relative isolate z-10 flex aspect-square size-auto w-full min-w-(--cell-size) flex-col gap-1 border-0 leading-none font-normal group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-[3px] group-data-[focused=true]/day:ring-ring/50 data-[range-end=true]:rounded-(--cell-radius) data-[range-end=true]:rounded-r-(--cell-radius) data-[range-end=true]:bg-primary data-[range-end=true]:text-primary-foreground data-[range-middle=true]:rounded-none data-[range-middle=true]:bg-muted data-[range-middle=true]:text-foreground data-[range-start=true]:rounded-(--cell-radius) data-[range-start=true]:rounded-l-(--cell-radius) data-[range-start=true]:bg-primary data-[range-start=true]:text-primary-foreground data-[selected-single=true]:bg-primary data-[selected-single=true]:text-primary-foreground dark:hover:text-foreground [&>span]:text-xs [&>span]:opacity-70",
        n.day,
        c
      ),
      ...u
    }
  );
}
export {
  R as Calendar,
  z as CalendarDayButton
};
//# sourceMappingURL=calendar.js.map
